import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AdminUser } from './entities';

const SESSION_STORAGE_KEY = 'gather.admin.session';

interface AuthState {
  admin: AdminUser | null;
}

const loadInitialAdmin = (): AdminUser | null => {
  try {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { user?: AdminUser };
    return parsed.user ?? null;
  } catch {
    return null;
  }
};

const initialState: AuthState = {
  admin: loadInitialAdmin(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAdmin: (state, action: PayloadAction<AdminUser>) => {
      state.admin = action.payload;
    },
    clearAdmin: (state) => {
      state.admin = null;
    },
  },
});

export const { setAdmin, clearAdmin } = authSlice.actions;
export default authSlice.reducer;
